<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-promosi" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Daftar Pemerintah Baru</b></h2>
        <h5>Pemerintah > Tambahkan Pemerintah</h5>
        <v-layout row wrap>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-building" label="Nama Instansi" name="namaInstansi" v-model="namaInstansi">
              </v-text-field>
              <small v-if="!isNamaInstansi" class="alert">Nama Instansi 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="phone" label="Kontak Instansi" name="kontakInstansi" v-model="kontakInstansi" type="number">
              </v-text-field>
              <small v-if="!isKontakInstansi" class="alert">Masukan Kontak Instansi Minimal 10 Digit</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-globe-americas" label="Website" name="website" v-model="website" >
              </v-text-field>
              <small v-if="!isWebsite" class="alert">Masukan Alamat Website</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-money" label="Nilai Bantuan" name="nilaiBantuan" v-model="nilaiBantuan" type="number" prefix="Rp. " suffix=".00">
              </v-text-field>
              <small v-if="!isNilaiBantuan" class="alert">Masukan Nilai Bantuan</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-crosshairs" label="Tujuan Bantuan" name="tujuanBantuan" v-model="tujuanBantuan">
              </v-text-field>
              <small v-if="!isTujuanBantuan" class="alert">Masukan Tujuan Bantuan</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-crosshairs" label="Alokasi Penggunaan Dana" name="alokasiPenggunaanDana" v-model="alokasiPenggunaanDana">
              </v-text-field>
              <small v-if="!isAlokasiPenggunaanDana" class="alert">Masukan Alokasi Penggunaan Dana</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-clock" label="Jangka Waktu" name="jangkaWaktu" v-model="jangkaWaktu" suffix="Tahun" type="number">
              </v-text-field>
              <small v-if="!isJangkaWaktu" class="alert">Masukan Jangka Waktu</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Upload Rencana Kerja" @click='pickFileRencanaKerja' v-model='rencanaKerjaName' prepend-icon='upload_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePickedRencanaKerja"
            >
            <small v-if="!isRencanaKerja" class="alert">Upload Rencana Kerja</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-check-circle" label="indikator Keberhasilan" name="indikatorKeberhasilan" v-model="indikatorKeberhasilan" suffix="Tahun" type="number">
              </v-text-field>
              <small v-if="!isIndikatorKeberhasilan" class="alert">Masukan Indikator Keberhasilan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Upload Penggunaan Dana" @click='pickFileUraianPenggunaanDana' v-model='uraianPenggunaanDanaName' prepend-icon='upload_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image2"
              accept="image/*"
              @change="onFilePickedUraianPenggunaanDana"
            >
            <small v-if="!isUraianPenggunaanDana" class="alert">Upload Uraian Penggunaan Dana</small>
          </v-flex>

          <!-- Kontrak Komoditas -->
          <!-- <v-flex xs6>
              <v-subheader><b>Daerah Sasaran Pendanaan</b></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-map-marked-alt" label="Desa" name="alamatDesa" v-model="alamatDesa">
              </v-text-field>
              <small v-if="!isAlamatDesa" class="alert">Masukan Desa</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatan" v-model="alamatKecamatan">
              </v-text-field>
              <small v-if="!isAlamatKecamatan" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
              <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten" name="alamatKabupaten" v-model="alamatKabupaten">
              </v-text-field>
              <small v-if="!isAlamatKabupaten" class="alert">Masukan Kabupaten</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsi"
              :items="tipeProvinsi"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsi" class="alert">Pilih Provinsi</small>
          </v-flex> -->

        </v-layout>        
        <br><br><br><br>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" form="tambahkan-promosi" @click="getPemerintah" :disabled="!isComplete">Tambahkan Pemerintah</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  components: {
    quillEditor
  },
  data: () => ({
    title: null,
    valid: true,
    date: null,

    // General Pemerintah
    namaInstansi: null,
    kontakInstansi: null,
    website: null,
    nilaiBantuan: null,
    tujuanBantuan: null,
    alokasiPenggunaanDana: null,
    jangkaWaktu: null,
    indikatorKeberhasilan: null,

    // Wilayah
    alamatDesa: null,
    alamatKecamatan: null,
    alamatKabupaten: null,
    alamatProvinsi: null,
    tipeProvinsi: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  
    rencanaKerjaName: null,
		rencanaKerjaUrl: null,
    rencanaKerjaImage: null,
    uraianPenggunaanDanaName: null,
		uraianPenggunaanDanaUrl: null,
		uraianPenggunaanDanaImage: null,
  }),

  computed: {
    // Form Check
    isComplete () {
      return (this.namaInstansi && this.namaInstansi.length >= 3) && (this.kontakInstansi && this.kontakInstansi >= 0 && this.kontakInstansi.length >= 8) && (this.website) && (this.nilaiBantuan && this.nilaiBantuan >= 0) && (this.tujuanBantuan) && (this.alokasiPenggunaanDana) && (this.jangkaWaktu && this.jangkaWaktu >= 1) && (this.rencanaKerjaName) && (this.indikatorKeberhasilan && this.indikatorKeberhasilan >= 1) && (this.uraianPenggunaanDanaName);
    },
        
    isNamaInstansi () {
      return (this.namaInstansi && this.namaInstansi.length >= 3);
    },

    isKontakInstansi(){
      return (this.kontakInstansi && this.kontakInstansi >= 0 && this.kontakInstansi.length >= 8)
    },

    isWebsite(){
      return (this.website)
    },

    isNilaiBantuan(){
      return (this.nilaiBantuan && this.nilaiBantuan >= 0)
    },

    isTujuanBantuan(){
      return (this.tujuanBantuan)
    },

    isAlokasiPenggunaanDana(){
      return (this.alokasiPenggunaanDana)
    },

    isJangkaWaktu(){
      return (this.jangkaWaktu && this.jangkaWaktu >= 1)
    },

    isRencanaKerja(){
      return (this.rencanaKerjaName)
    },

    isIndikatorKeberhasilan(){
      return (this.indikatorKeberhasilan && this.indikatorKeberhasilan >= 1)
    },

    isUraianPenggunaanDana(){
      return (this.uraianPenggunaanDanaName)
    },

    isAlamatDesa(){
      return (this.alamatDesa)
    },

    isAlamatKecamatan(){
      return (this.alamatKecamatan)
    },

    isAlamatKabupaten(){
      return (this.alamatKabupaten)
    },

    isAlamatProvinsi(){
      return (this.alamatProvinsi)
    },

  },

  methods: {
    pickFileRencanaKerja () {
      this.$refs.image.click ()
    },
		
		onFilePickedRencanaKerja (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.rencanaKerjaName = files[0].name
				if(this.rencanaKerjaName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.rencanaKerjaUrl = fr.result
					this.rencanaKerjaImage = files[0] // this is an image file that can be sent to server...
				})
			} else {
				this.rencanaKerjaName = ''
				this.rencanaKerjaImage = ''
				this.rencanaKerjaUrl = ''
			}
		},

    pickFileUraianPenggunaanDana () {
      this.$refs.image2.click ()
    },
		
		onFilePickedUraianPenggunaanDana (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.uraianPenggunaanDanaName = files[0].name
				if(this.uraianPenggunaanDanaName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.uraianPenggunaanDanaUrl = fr.result
					this.uraianPenggunaanDanaImage = files[0] // this is an image file that can be sent to server...
				})
			} else {
				this.uraianPenggunaanDanaName = ''
				this.uraianPenggunaanDanaImage = ''
				this.uraianPenggunaanDanaUrl = ''
			}
		},

    closeDialog () {
      this.$parent.isActive = false;
    },

    getPemerintah (){
      // General
      localStorage.pemerintahID = 'PEM-00010'
      localStorage.pemerintahNamaInstansi = this.namaInstansi,
      localStorage.pemerintahKontakInstansi = this.kontakInstansi,
      localStorage.pemerintahWebsite = this.website,
      localStorage.pemerintahNilaiBantuan = this.nilaiBantuan,
      localStorage.pemerintahTujuanBantuan = this.tujuanBantuan,
      localStorage.pemerintahAlokasiPenggunaanDana = this.alokasiPenggunaanDana,
      localStorage.pemerintahJangkaWaktu = this.jangkaWaktu,
      localStorage.pemerintahIndikatorKeberhasilan = this.indikatorKeberhasilan,

      // Wilayah
      // localStorage.pemerintahAlamatDesa = this.alamatDesa,
      // localStorage.pemerintahAlamatKecamatan = this.alamatKecamatan,
      // localStorage.pemerintahAlamatKabupaten = this.alamatKabupaten,
      // localStorage.pemerintahAlamatProvinsi = this.alamatProvinsi,

      window.getApp.$emit('APP_PEMERINTAH_SUCCESS');
    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
